/** @jsxImportSource @emotion/react */
import React from 'react'
import StatementPaymentPortal from './verifyContract/StatementPaymentPortal'

const StatementPaymentRouter: React.FC = () => {
  return <StatementPaymentPortal />
}

export default StatementPaymentRouter
